import { IconProps } from "ztypes/icon-props";

const IconUp: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.64645 10.7203C2.45118 10.525 2.45118 10.2084 2.64645 10.0131L7.64645 5.01315C7.84171 4.81788 8.15829 4.81788 8.35355 5.01315L13.3536 10.0131C13.5488 10.2084 13.5488 10.525 13.3536 10.7203C13.1583 10.9155 12.8417 10.9155 12.6464 10.7203L8 6.07381L3.35355 10.7203C3.15829 10.9155 2.84171 10.9155 2.64645 10.7203Z"
          fill="#0D0D0D"
        />
      </g>
    </svg>
  );
};

export default IconUp;
